import { render } from "./EventAppLayoutHeader.vue?vue&type=template&id=3a370bbd&ts=true"
import script from "./EventAppLayoutHeader.vue?vue&type=script&lang=ts"
export * from "./EventAppLayoutHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__